export function GetApiUrl() {
    // @ts-ignore
    var l = window.location;
    var url = l.protocol + "//" + l.host;

    return url;
}